import { z } from "zod";
import {
  ASSET_TYPES,
  CHANNEL_TYPES,
  CHECK_TYPES,
  DNS_RECORD_TYPES,
  MAINTENANCE_WINDOW_POLICIES,
  PERMISSIONS,
  REPORT_FORMATS,
  REPORT_TYPES,
  ROLES,
  SAFE_HTTP_METHODS,
  SCOPE_TYPES,
  SEVERITIES,
  SLO_OBJECTIVES,
  STATUS_PAGE_VISIBILITIES,
  VERIFICATION_METHODS,
} from "@ghostwatch/shared-types";

export const uuidSchema = z.string().uuid();
/** RFC3339 timestamp. We only validate it parses as a real instant, not a specific format. */
export const timestampSchema = z.string().refine((v) => !Number.isNaN(Date.parse(v)), {
  message: "must be a valid RFC3339 timestamp",
});

export const scopeTypeSchema = z.enum(SCOPE_TYPES);
export const verificationMethodSchema = z.enum(VERIFICATION_METHODS);
export const assetTypeSchema = z.enum(ASSET_TYPES);
export const severitySchema = z.enum(SEVERITIES);
export const checkTypeSchema = z.enum(CHECK_TYPES);
export const dnsRecordTypeSchema = z.enum(DNS_RECORD_TYPES);
export const safeHttpMethodSchema = z.enum(SAFE_HTTP_METHODS);
export const channelTypeSchema = z.enum(CHANNEL_TYPES);
export const maintenanceWindowPolicySchema = z.enum(MAINTENANCE_WINDOW_POLICIES);
export const sloObjectiveSchema = z.enum(SLO_OBJECTIVES);
export const statusPageVisibilitySchema = z.enum(STATUS_PAGE_VISIBILITIES);
export const reportTypeSchema = z.enum(REPORT_TYPES);
export const reportFormatSchema = z.enum(REPORT_FORMATS);
export const roleSchema = z.enum(ROLES);
export const permissionSchema = z.enum(PERMISSIONS);

export const assetFilterSchema = z
  .object({
    asset_ids: z.array(uuidSchema).optional(),
    asset_types: z.array(assetTypeSchema).optional(),
    tags: z.array(z.string()).optional(),
    environment: z.string().optional(),
  })
  .partial();
export type AssetFilterInput = z.infer<typeof assetFilterSchema>;

/** Wraps an item schema in the `{ items, next_cursor }` envelope every list endpoint uses. */
export function pageSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    next_cursor: z.string().nullish(),
  });
}

/** Builds a single-key "externally tagged" object schema, e.g. `{ http_status: {...} }`. */
export function tagged<K extends string, T extends z.ZodTypeAny>(key: K, value: T) {
  return z.object({ [key]: value } as Record<K, T>).strict();
}
